export const buildProxyUrl = (host, encodedRedirectUrl) => {
  return `https://${host}/proxy-api-request?redirect=${encodedRedirectUrl}`;
};

export const redirectToIamBff = (config, apigeeUrl) => {
  config.url = config.url
    .replace(/\{/g, '%7B')
    .replace(/}/g, '%7D')
    .replace(/\+/g, '%2B')
    .replace(/"/g, '%22')
    .replace(/ /g, '%20')
    .replace(/™/g, '%E2%84%A2');
  config.url = encodeURIComponent(config.url);
  if (process.env.VUE_APP_DOMAIN_PATH.includes('localhost')) {
    config.baseURL = '/fleet-account' + config.baseURL;
  } else {
    const encodedApigeeUrl = encodeURIComponent(apigeeUrl);
    const host = window.location.hostname.includes('stage')
      ? 'stage.ford.com'
      : 'ford.com';
    config.baseURL = `https://bff.${host}/pro/bff/v1/proxy?resourceUrl=${encodedApigeeUrl}`;
  }
};

export const isExemptedPath = (requestUrl, exemptedUrls, apiPrefix) => {
  try {
    const url = new URL(requestUrl, 'https://example.com');
    let pathToCheck = url.pathname;

    if (pathToCheck.startsWith(apiPrefix)) {
      pathToCheck = pathToCheck.substring(apiPrefix.length);
    }

    if (!pathToCheck.startsWith('/')) {
      pathToCheck = '/' + pathToCheck;
    }

    return exemptedUrls.some((exemptedUrl) => {
      const normalizedUrl = exemptedUrl.startsWith('/')
        ? exemptedUrl
        : '/' + exemptedUrl;

      if (normalizedUrl.endsWith('**')) {
        return pathToCheck.startsWith(normalizedUrl.slice(0, -2));
      }
      return (
        pathToCheck === normalizedUrl ||
        pathToCheck.startsWith(normalizedUrl + '/')
      );
    });
  } catch {
    return false;
  }
};
